// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___, * as ___CSS_LOADER_ICSS_IMPORT_0____NAMED___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[1].use[1]!../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[1].oneOf[1].use[2]!../dash-collaboration-status/dash-collaboration-status.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.chat_wrapper_kJQha {
    position: relative;
    flex-shrink: 0;
}

.chat_toggle_jdVkX {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.chat_badge_VHsxA {
    padding: 0 0.3rem;
    border-radius: calc(0.5rem / 2);
    background: var(--looks-secondary);
    color: white;
    font-size: 0.75rem;
}

.chat_panel_HsclR {
    position: absolute;
    inset-inline-end: 0;
    top: calc(100% + 0.5rem);
    z-index: 480;
    display: flex;
    flex-direction: column;
    width: min(22rem, calc(100vw - 2rem));
    height: min(28rem, calc(100vh - 8rem));
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    overflow: hidden;
    background: var(--ui-modal-background);
    color: var(--ui-modal-foreground);
    box-shadow: 0 0.25rem 1rem var(--shadow);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.875rem;
    text-align: start;
}

.chat_panel_HsclR * {
    box-sizing: border-box;
}

.chat_header_Zh_MA {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 3.125rem;
    padding: 0.75rem 1rem;
    background: var(--ui-modal-header-background);
    color: var(--ui-modal-header-foreground);
    font-size: 1rem;
}

.chat_close_TvHsN {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: var(--ui-black-transparent);
    cursor: pointer;
}

.chat_close_TvHsN img {
    transform: rotate(45deg);
}

.chat_messages_KS55L {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 0.75rem 1rem;
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text;
}

.chat_message_Net9q + .chat_message_Net9q {
    margin-top: 0.875rem;
}

.chat_meta_pN7iU {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.5rem;
}

.chat_meta_pN7iU time {
    flex-shrink: 0;
    opacity: 0.65;
    font-size: 0.75rem;
}

.chat_username_ZYBPO {
    overflow-wrap: anywhere;
    unicode-bidi: plaintext;
}

.chat_text_rD4Yy {
    margin-top: 0.25rem;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    unicode-bidi: plaintext;
    line-height: 1.4;
}

.chat_empty_dJ_vZ {
    opacity: 0.7;
    text-align: center;
}

.chat_form_Uo5AD {
    padding: 0.75rem 1rem;
    border-top: 1px solid var(--ui-black-transparent);
}

.chat_label_A0yX5 {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.chat_input_qtep6 {
    width: 100%;
    min-height: 3.5rem;
    padding: 0.5rem;
    resize: none;
    border: 1px solid var(--ui-black-transparent);
    border-radius: calc(0.5rem / 2);
    background: var(--input-background);
    color: var(--text-primary);
    font: inherit;
}

.chat_input_qtep6:focus {
    outline: 2px solid var(--looks-secondary);
    outline-offset: 1px;
}

.chat_footer_n80BZ {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
    font-size: 0.75rem;
}

.chat_send_jbjzB {
    padding: 0.5rem 1rem;
    border: 1px solid var(--looks-secondary);
    border-radius: calc(0.5rem / 2);
    background: var(--looks-secondary);
    color: white;
    font: inherit;
    font-weight: bold;
    cursor: pointer;
}

.chat_send_jbjzB:disabled,
.chat_input_qtep6:disabled {
    opacity: 0.5;
    cursor: default;
}

.chat_notice_wiO2A {
    margin: 0.5rem 0;
    font-size: 0.75rem;
    line-height: 1.4;
}

.chat_sr-only_JjtgE {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    -webkit-clip-path: inset(50%);
            clip-path: inset(50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-collaboration-chat/chat.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,sCAAsC;IACtC,6CAA6C;IAC7C,qBAAqB;IACrB,gBAAgB;IAChB,sCAAsC;IACtC,iCAAiC;IACjC,wCAAwC;IACxC,2DAA2D;IAC3D,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;IACrB,6CAA6C;IAC7C,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,mCAAmC;IACnC,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;IACxC,+BAA+B;IAC/B,kCAAkC;IAClC,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,6BAA6B;YACrB,qBAAqB;AACjC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.wrapper {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.toggle {\n    composes: button from \"../dash-collaboration-status/dash-collaboration-status.css\";\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.badge {\n    padding: 0 0.3rem;\n    border-radius: calc(0.5rem / 2);\n    background: var(--looks-secondary);\n    color: white;\n    font-size: 0.75rem;\n}\n\n.panel {\n    position: absolute;\n    inset-inline-end: 0;\n    top: calc(100% + 0.5rem);\n    z-index: 480;\n    display: flex;\n    flex-direction: column;\n    width: min(22rem, calc(100vw - 2rem));\n    height: min(28rem, calc(100vh - 8rem));\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    overflow: hidden;\n    background: var(--ui-modal-background);\n    color: var(--ui-modal-foreground);\n    box-shadow: 0 0.25rem 1rem var(--shadow);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.875rem;\n    text-align: start;\n}\n\n.panel * {\n    box-sizing: border-box;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 3.125rem;\n    padding: 0.75rem 1rem;\n    background: var(--ui-modal-header-background);\n    color: var(--ui-modal-header-foreground);\n    font-size: 1rem;\n}\n\n.close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2rem;\n    height: 2rem;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: var(--ui-black-transparent);\n    cursor: pointer;\n}\n\n.close img {\n    transform: rotate(45deg);\n}\n\n.messages {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding: 0.75rem 1rem;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n}\n\n.message + .message {\n    margin-top: 0.875rem;\n}\n\n.meta {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 0.5rem;\n}\n\n.meta time {\n    flex-shrink: 0;\n    opacity: 0.65;\n    font-size: 0.75rem;\n}\n\n.username {\n    overflow-wrap: anywhere;\n    unicode-bidi: plaintext;\n}\n\n.text {\n    margin-top: 0.25rem;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    unicode-bidi: plaintext;\n    line-height: 1.4;\n}\n\n.empty {\n    opacity: 0.7;\n    text-align: center;\n}\n\n.form {\n    padding: 0.75rem 1rem;\n    border-top: 1px solid var(--ui-black-transparent);\n}\n\n.label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.input {\n    width: 100%;\n    min-height: 3.5rem;\n    padding: 0.5rem;\n    resize: none;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: calc(0.5rem / 2);\n    background: var(--input-background);\n    color: var(--text-primary);\n    font: inherit;\n}\n\n.input:focus {\n    outline: 2px solid var(--looks-secondary);\n    outline-offset: 1px;\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 0.5rem;\n    font-size: 0.75rem;\n}\n\n.send {\n    padding: 0.5rem 1rem;\n    border: 1px solid var(--looks-secondary);\n    border-radius: calc(0.5rem / 2);\n    background: var(--looks-secondary);\n    color: white;\n    font: inherit;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.send:disabled,\n.input:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.notice {\n    margin: 0.5rem 0;\n    font-size: 0.75rem;\n    line-height: 1.4;\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    -webkit-clip-path: inset(50%);\n            clip-path: inset(50%);\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `chat_wrapper_kJQha`;
export var toggle = `chat_toggle_jdVkX ${___CSS_LOADER_ICSS_IMPORT_0____NAMED___["button"]}`;
export var badge = `chat_badge_VHsxA`;
export var panel = `chat_panel_HsclR`;
export var header = `chat_header_Zh_MA`;
export var close = `chat_close_TvHsN`;
export var messages = `chat_messages_KS55L`;
export var message = `chat_message_Net9q`;
export var meta = `chat_meta_pN7iU`;
export var username = `chat_username_ZYBPO`;
export var text = `chat_text_rD4Yy`;
export var empty = `chat_empty_dJ_vZ`;
export var form = `chat_form_Uo5AD`;
export var label = `chat_label_A0yX5`;
export var input = `chat_input_qtep6`;
export var footer = `chat_footer_n80BZ`;
export var send = `chat_send_jbjzB`;
export var notice = `chat_notice_wiO2A`;
var _1 = `chat_sr-only_JjtgE`;
export { _1 as "sr-only" };
export var srOnly = `chat_sr-only_JjtgE`;
export default ___CSS_LOADER_EXPORT___;
